export const SET_CASE_BASEMENT_LEVELS_COUNT = 'SET_CASE_BASEMENT_LEVELS_COUNT';

export const setCaseBasementLevelsCount = (caseId: string, basementLevelsCount?: number) => ({
  type: SET_CASE_BASEMENT_LEVELS_COUNT,
  payload: { caseId, basementLevelsCount }
});

export type SetCaseBasementLevelsCountAction = ReturnType<typeof setCaseBasementLevelsCount>;
